// Overnight auto-reload of open tabs: pure decision logic (UK time regardless of the PC's timezone).
export const IDLE_MS = 15 * 60 * 1000;
export const MAX_AGE_MS = 20 * 3600 * 1000;
export const CHECK_MS = 5 * 60 * 1000;
export const NIGHT_KEY = "cts_auto_reload_night";
export const JITTER_KEY = "cts_auto_reload_jitter";

const FMT = new Intl.DateTimeFormat("en-GB", { timeZone: "Europe/London", hourCycle: "h23", year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit" });

export const londonParts = (ms) => {
  const p = Object.fromEntries(FMT.formatToParts(new Date(ms)).map((x) => [x.type, x.value]));
  return { date: `${p.year}-${p.month}-${p.day}`, mins: (Number(p.hour) % 24) * 60 + Number(p.minute) };
};

const toMins = (hhmm) => { const [h, m] = hhmm.split(":").map(Number); return h * 60 + m; };

// Minutes since the window opened (handles windows past midnight), or null outside it.
export const windowOffset = (ms, start, end) => {
  const s = toMins(start), len = (toMins(end) - s + 1440) % 1440;
  const off = (londonParts(ms).mins - s + 1440) % 1440;
  return off < len ? off : null;
};

// The London date on which tonight's window started: one reload per night per tab.
export const nightKey = (ms, start, end) => {
  const off = windowOffset(ms, start, end);
  return off === null ? null : londonParts(ms - off * 60000).date;
};

export const decide = ({ now, settings, openedAt, lastActivity, versionStale, dirty, uploading, lastNight, jitterMin = 0 }) => {
  if (!settings?.enabled) return { reload: false, reason: "off" };
  const off = windowOffset(now, settings.start, settings.end);
  if (off === null) return { reload: false, reason: "outside_window" };
  const night = nightKey(now, settings.start, settings.end);
  if (lastNight === night) return { reload: false, reason: "already_tonight", night };
  if (off < jitterMin) return { reload: false, reason: "jitter", night };
  if (!versionStale && now - openedAt <= MAX_AGE_MS) return { reload: false, reason: "fresh", night };
  if (now - lastActivity < IDLE_MS) return { reload: false, reason: "active", night };
  if (dirty) return { reload: false, reason: "unsaved", night };
  if (uploading) return { reload: false, reason: "uploading", night };
  return { reload: true, reason: versionStale ? "new_version" : "tab_age", night };
};

// Per-tab random 0–10 min offset so many tabs don't reload at the same moment (kept for the whole tab session).
export const tabJitter = () => {
  let j = sessionStorage.getItem(JITTER_KEY);
  if (j === null) { j = String(Math.floor(Math.random() * 11)); sessionStorage.setItem(JITTER_KEY, j); }
  return Number(j);
};
